import makeStyles from "@mui/styles/makeStyles";
import {useDispatch, useSelector} from 'react-redux';
import {
    getMarkedOperation,
    reload,
    setMarkedOperation,
} from '../../../../store/reducers/booked_admissions';
import React, {useEffect} from 'react';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import AddIcon from '@mui/icons-material/Add';
import moment from "moment";
import AgyleDialog from '../../../../components/modal/agyleDialog';
import useOpenState from '../../../../hooks/useOpenState';
import AddInformationModal from './addInformationModal';
import {InformationTab} from './information';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import AgyleSelectField from '../../../../components/ui/selector/agyleSelectField';
import MenuItem from '@mui/material/MenuItem';
import ClearIcon from "@mui/icons-material/Clear";
import uuidv4 from 'uuid/v4';
import PatientAlertsComponent from '../../../bookAdmission/patientAlertsComponent';
import CheckIcon from '@mui/icons-material/Check';
import MessageBox from '../../../../util/messageBox';
import API from '../../../../app/api';
import {admissionViewTypes} from '../../bookedAdmissions';
import {hasBAPermission, Permissions} from '../../../../store/reducers/user';
import {setSnackbar} from '../../../../store/reducers/globals';

export const useStyles = makeStyles((theme) => ({
    header: {
        height: "50px",
        margin: "10px 0px",
        fontSize: "16px",
        background: theme.palette.mode === "dark" ? "#313233" : "#dee1e5",
        fontWeight: "bold",
        borderRadius: "7px",
        display: "flex",
        alignItems: "center",
        paddingLeft: "10px",
        paddingRight: "10px",
        justifyContent: "space-between"
    },
    procedureSpecialty: {
        width: "70px",
        border: "1px solid grey",
        display: "inline-flex",
        padding: "3px",
        borderRadius: "8px",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 500,
        margin: "0px 5px"
    },
    procedure: {

    },
    select: {
     // background: theme.palette.background.paper
    },
    column: {
        padding: 10,
        fontSize: 12,

    },
    row: {
        background: theme.palette.bookAdmissions.infoRowBackground,
        marginBottom: 10,
        borderRadius: 5
    },
    noItems: {
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "24px",
        letterSpacing: "0em",
        textAlign: "center",
        marginTop: 50
    },
    label: {
        color: theme.palette.admissionForm.labelColor,
    },
    columnLabel: {
        color: "#ACAFB3",
        marginBottom: 3
    },
    statusDot: {
        width: "10px",
        height: "10px",
        borderRadius: "10px",
        display: "inline-block",
        marginRight: "10px"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    }
}));




export const DecisionModel = {
    source: "decisions",
    object: {
        date: null,
        user: "",
        decision: "",
        status: "",
        id: "",
    },
    statusTypes: [
        {
            description: "Reviewed",
            value: "reviewed",
        },
        {
            description: "Waiting to review",
            value: "waiting",
        }
    ],
    valueMapper: {
        reviewed: {
            color: "green",
            description: "Reviewed",
        },
        waiting: {
            color: "red",
            description: "Waiting to review",
        }
    },
    tableColumns: [
        {
            field: "date",
            format: "date",
            label: "Entry Date"
        },
        {
            field: "user",
            format: "string",
            label: "User",
            disabled: true
        },
        {
            field: "decision",
            format: "string",
            label: "Decision"
        },
        {
            field: "status",
            format: "status",
            label: "Status"
        }
    ]
}

export const ContactHistoryModel = {
        source: "contactHistory",
        object: {
            date: null,
            user: "",
            source: "",
            type: "",
            status: "",
            id: "",
        },
        statusTypes: [
            {
                description: "Unanswered",
                value: "unanswered",
            },
            {
                description: "Answered",
                value: "answered",
            }
        ],
        sourceTypes: [
            {
                description: "Patient Initiated",
                value: "patientInitiated",
            },
            {
                description: "Trust Initiated",
                value: "trustInitiated",
            }
        ],

        valueMapper: {
            unanswered: {
                color: "red",
                description: "Unanswered",
            },
            answered: {
                color: "green",
                description: "Answered",
            },
            trustInitiated: {
                description: "Trust Initiated",
            },
            patientInitiated: {
                description: "Patient Initiated",
            }
        },

    tableColumns: [
        {
            field: "date",
            format: "date",
            label: "Entry Date"
        },
        {
            field: "user",
            format: "string",
            label: "User",
            disabled: true
        },
        {
            field: "source",
            format: "source",
            label: "Source"
        },
        {
            field: "type",
            format: "string",
            label: "Notes"
        },
        {
            field: "status",
            format: "status",
            label: "Status"
        }
    ]
}

const AdmissionDecisions = (props) => {

    const dispatch = useDispatch();

    const classes = useStyles();
    const markedOperation = useSelector(getMarkedOperation);
    const [model, setModel] = React.useState(DecisionModel);
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);
    const [isAcceptModalOpen, openAcceptModal, closeAcceptModal] = useOpenState(false, true);
    const controller = new AbortController();

    useEffect(()=>{
        if(props.type === InformationTab.DECISIONS)
            setModel(DecisionModel)
        else
            setModel(ContactHistoryModel)

        clearFilter();
    },[props.type])


    const [rowToEdit, setRowToEdit] = React.useState(null);

    const editInformationRow = (row) => {
        if(userCanManage()){
            setRowToEdit(row);
            openModal()
        } else {
            dispatch(setSnackbar({
                type: "warning",
                message: "No permission to edit",
            }));
        }
    }

    const handleCloseAcceptModal = () => {
        closeAcceptModal();
    }

    const handleSubmitAcceptModal = () => {

            let operationTmp = _.cloneDeep(markedOperation);
            operationTmp['patientAcceptsToComeIn'] = {
                status: true,
            }

            let patientTmp = operationTmp["patient"]
            let sessiosObjTmp = operationTmp["sessiosObj"];

            delete operationTmp.sessiosObj;
            delete operationTmp.patient;

            delete operationTmp.href;
            delete operationTmp.type;

            if(operationTmp.overseeingConsultant) {
                operationTmp.overseeingConsultant = {
                    id: operationTmp.overseeingConsultant.id,
                    name: operationTmp.overseeingConsultant.name,
                }
            }

            API.admissionUpdate(operationTmp, controller.signal).then(
              (res) => {
                  dispatch(reload());
                  dispatch(setMarkedOperation({
                      ...res,
                      patient: patientTmp,
                      sessiosObj: sessiosObjTmp
                  }));
                  closeAcceptModal();
              }
            )

    }

    const sortTypes = [
        {id: 1, field: "date", order: "desc", label: "Entry Date: Newest"},
        {id: 2, field: "date", order: "asc", label: "Entry Date: Oldest"}
    ]

    const [sort, setSort] = React.useState(sortTypes[0]);
    const [filter, setFilter] = React.useState("");

    const clearFilter = () => {
        setFilter("");
    }

    const sortedList = () => {
        return filter? _.orderBy(markedOperation?.[model.source], [sort.field], [sort.order]).filter(element => {
                return element.status === filter;
            })
            : _.orderBy(markedOperation?.[model.source], [sort.field], [sort.order])
    }



    const handleSetSort = (id) => {
        setSort(sortTypes.find((el) => el.id === id));
    }

    const renderCustomOption = (opt) => {
        return (
            <MenuItem
                key={opt.label}
                value={opt.id}
            >
                {opt.label}
            </MenuItem>
        );
    };

    const renderCustomOptionFilter = (opt) => {
        return (
            <MenuItem
                key={opt.value}
                value={opt.value}
            >
                {opt.description}
            </MenuItem>
        );
    };

    const handleAddRow = () => {
        setRowToEdit(null);
        openModal();
    }

    const userCanManage = () => {
        //BA_CAN_MANAGE_MDU_DECISIONS
        //BA_CAN_MANAGE_DECISIONS
        //BA_CAN_MANAGE_MDU_CONTACT_JOURNAL
        //BA_CAN_MANAGE_CONTACT_JOURNAL

        let role = 'BA_CAN_MANAGE_';

        if(admissionViewTypes.MDU === props.admissionType) role += 'MDU_';

        if(props.type === InformationTab.DECISIONS) role += 'DECISIONS';
        else role += 'CONTACT_JOURNAL';

        return dispatch(hasBAPermission(Permissions[role], props.admissionType));

    }

    return (<div>
        <AgyleDialog
            title={"Add"}
            open={isModalOpen}
            onClose={closeModal}
            disableActions
            closeButtonOnHeader
            contentStyle={classes.dialogContentStyle}
        >
            <AddInformationModal model={model} row = {rowToEdit} onClose={closeModal}/>
        </AgyleDialog>

        <MessageBox
          title={"Patient accepts to come in."}
          haveAccept={{yes: "Accept", no: "Close"}}
          warning
          bookAdmission
          onAccept={handleSubmitAcceptModal}
          onClose={handleCloseAcceptModal}
          message={"Are you sure the patient agrees to come in?"}
          open={isAcceptModalOpen}
        />

        <div className={classes.header}>
            <div style={{display: "flex", alignItems: "center"}}>
                <div style={{marginRight: 10}}> {markedOperation?.patientName}</div>
                <div style={{marginRight: 10}}>
                    {markedOperation && <PatientAlertsComponent patientObject = {markedOperation?.patient}/>}
                </div>
                {markedOperation?.procedures.map((procedure, index) => {
                    return <div className={classes.procedure}>
                                <div className={classes.procedureSpecialty}> {procedure?.specialty} </div>
                            </div>
                })}
                <div style={{width: 150, marginLeft: 20}}>
                    <AgyleSelectField
                        onChange={setFilter}
                        name={"filter"}
                        options={model.statusTypes}
                        value={filter}
                        withBorder
                        padding={"3px"}
                        label={"Status"}
                        size={"small"}
                        className={classes.select}
                     //   style={{minHeight: "30px"}}
                        customObject={renderCustomOptionFilter}
                        clearButtonVisible
                    />
                </div>


                <div style={{width: 200, marginLeft: 10}}>

                    <AgyleSelectField
                        onChange={handleSetSort}
                        name={"sort"}
                        options={sortTypes}
                        value={sort.id}
                        withBorder
                    //    withBackground
                        padding={"3px"}
                        size={"small"}
                        className={classes.select}
                        defaultClearValue={null}
                        customObject={renderCustomOption}
                        clearButtonVisible={false}
                    />
                </div>
            </div>

            <div style={{display: "flex"}}>
                {markedOperation.bookedSession &&
                <AgyleButton
                    size="small"
                    onClick={openAcceptModal}
                    startIcon={<CheckIcon/>}
                    color={markedOperation?.patientAcceptsToComeIn?.status ? "success" : "primary"}
                    variant={"contained"}
                    style={{marginRight: 10}}
                    disabled={markedOperation?.patientAcceptsToComeIn?.status || !userCanManage()}
                >
                    <div>
                        {markedOperation?.patientAcceptsToComeIn?.status ? '': 'Accept'}
                        <div style={{fontSize: 10}}>{markedOperation?.patientAcceptsToComeIn?.status? "Accepted " + moment(markedOperation?.patientAcceptsToComeIn.date).format("DD/MM/YYYY HH:mm") + " by "+ markedOperation?.patientAcceptsToComeIn.user : ""} </div>
                    </div>
                </AgyleButton>
                }

                <AgyleButton
                    size="small"
                    onClick={handleAddRow}
                    disabled={!userCanManage()}
                    startIcon={<AddIcon/>}>
                    Add
                </AgyleButton>
            </div>

        </div>

        <div style={{height: "calc(100vh - 230px)"}} className={"scroll-normal-white"}>
            {sortedList()?.length === 0 && <div className={classes.noItems}> There are no {props.type === InformationTab.DECISIONS? "decisions": "contact history"} for this patient yet. </div>}
            {sortedList()?.map((item) => {
                return <div className={classes.row} onClick={() => editInformationRow(item)}>
                    <Grid container spacing={0}>
                        {model.tableColumns.map((column)=>{
                            let columnRender;
                            switch(column.format) {
                                case "string":
                                    columnRender = <Grid item xs = {12/model.tableColumns.length}>
                                        <div className={classes.column}> <div className={classes.columnLabel}>{column.label}</div> {item[column.field]} </div>
                                    </Grid>
                                    break;
                                case "date":
                                    columnRender = <Grid item xs = {12/model.tableColumns.length}>
                                        <div className={classes.column}> <div className={classes.columnLabel}>{column.label} </div>{moment(item[column.field]).format("DD/MM/YYYY HH:mm")}</div></Grid>
                                    break;
                                case "status":
                                    columnRender = <Grid item xs = {12/model.tableColumns.length}>
                                        <div className={classes.column}> <div className={classes.columnLabel}>{column.label} </div>
                                            <div style={{background: model.valueMapper[item[column.field]]?.color}} className={classes.statusDot}/>
                                            {model.valueMapper[item[column.field]]?.description}
                                        </div></Grid>
                                    break;
                                case "source":
                                    columnRender = <Grid item xs = {12/model.tableColumns.length}>
                                        <div className={classes.column}> <div className={classes.columnLabel}>{column.label} </div>
                                            {model.valueMapper[item[column.field]]?.description}
                                        </div></Grid>
                                    break;

                            }
                            return columnRender;
                        })}
                    </Grid>
                </div>
            })}
        </div>
    </div>)
}

export default AdmissionDecisions